/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

/** Import exported objects from lower level directories */



/** Import exported objects from current directory files */

import { ForagerTypes } from './forager.types';
import { GearTypes } from './gear.types';
import { GraphicssettingTypes } from './graphicsSetting.types';
import { NvperfmonTypes } from './NvPerfMon.types';
import { OscTypes } from './osc.types';
import { SdkTypes } from './sdk.types';
import { ShareserverTypes } from './shareServer.types';

/** Export current level object and nested objects */

export module ShareTypes {
export import Forager = ForagerTypes;
export import Gear = GearTypes;
export import Graphicssetting = GraphicssettingTypes;
export import Nvperfmon = NvperfmonTypes;
export import Osc = OscTypes;
export import Sdk = SdkTypes;
export import Shareserver = ShareserverTypes;
}


